import { apiRequest } from './api'

export function listPayments() {
  return apiRequest('/payments/list', {
    method: 'POST',
  })
}

export function createPayment(payload) {
  return apiRequest('/payments/create', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export function updatePayment(payload) {
  return apiRequest('/payments/update', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export function deletePayment(paymentId) {
  return apiRequest('/payments/delete', {
    method: 'POST',
    body: JSON.stringify({ paymentId }),
  })
}
